/**
 * Removes all characters from string except digits
 * @param str input string
 * @example
 * const digits = removeNonDigits('a+98--RR'); // => '98'
 */
export function removeNonDigits(str: string | null | undefined): string {
  return (str ?? '').replace(/\D/g, '');
}
